import moment from 'moment';
import { useEffect, useState } from 'react';
import { AddToCalendarEvent } from 'react-add-to-calendar';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { get, isEqual } from 'lodash';

import { usePrevious } from '@lib/hooks';
import { Appointment, Availability } from '@lib/resources/types';

import { useAddress } from 'hooks';

const messages = defineMessages({
  title: {
    id: 'app.components.AppointmentDetails.AppointmentDetailsProvider.hooks.useAddToCalendarEvent.title',
    defaultMessage: 'Appointment with {provider}',
  },
  telehealthAddress: {
    id: 'app.components.AppointmentDetails.AppointmentDetailsProvider.hooks.useAddToCalendarEvent.telehealthAddress',
    defaultMessage: 'Telehealth - Online appointment',
  },
});

export default function useAddToCalendarEvent(data?: Appointment | Availability) {
  const { formatMessage } = useIntl();

  const [event, setEvent] = useState<AddToCalendarEvent>();

  const isTelehealth = get(data, 'type.modality') === 'telehealth';

  const prevData = usePrevious(data);
  const location = useAddress(data && data.facility ? data.facility : {});

  useEffect(() => {
    if (data && !isEqual(data, prevData) && data.facility && data.provider) {
      const endTime = moment(data.date)
        .add(data.duration, 'minutes')
        .toISOString();

      setEvent({
        title: formatMessage(messages.title, { provider: data.provider.name }),
        location: isTelehealth ? formatMessage(messages.telehealthAddress) : location,
        startTime: data.date,
        endTime,
      });
    }
  }, [data, prevData, formatMessage, location, isTelehealth]);

  return event;
}
